import { render, staticRenderFns } from "./ProgrammeFinishStudent.vue?vue&type=template&id=5139fae2&"
import script from "./ProgrammeFinishStudent.vue?vue&type=script&lang=ts&"
export * from "./ProgrammeFinishStudent.vue?vue&type=script&lang=ts&"
import style0 from "./ProgrammeFinishStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports